import "./App.css";
import Board from "./Components/Board/Board";
import Header from "./Components/Header/Header";

function App() {
  return (
    <div className="App">
      <Header />
      <Board />
    </div>
  );
}

export default App;
